import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  errors: any;

  constructor() {}
  setErrors(err) {
    this.errors = err;
  }

  getErrors() {
    return this.errors;
  }
}
